import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetPartnerKey = (): string | undefined => {
  const state = useConstructorContextState();

  return get(state, ['partnerKey']);
};
